Object.defineProperty(exports, '__esModule', { value: true });

var hooks_useCustomWebkitScrollbar = require('./useCustomWebkitScrollbar.js');
var hooks_useIsMounted = require('./useIsMounted.js');

var hooks = {
    useCustomWebkitScrollbar: hooks_useCustomWebkitScrollbar.useCustomWebkitScrollbar,
};

exports.useIsMounted = hooks_useIsMounted.useIsMounted;
exports.hooks = hooks;
